import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoggerService } from './service/logger.service';

@NgModule({
  declarations: [],
  exports: [],
  imports: [RouterModule],
  providers: [LoggerService, provideHttpClient(withInterceptorsFromDi())],
})
export class LoggerModule {}
